import {
  PADDING,
  PADDING_PHONE,
  WIDTH,
} from 'fitify-ui-landing/src/components/Container/Container.Styled'
import { phone } from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`

export const StyledReviewsContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 16px max(${PADDING}, calc((100vw - ${WIDTH}) / 2));
  gap: 12px;
  -webkit-overflow-scrolling: touch;
  overflow-x: auto;
  scroll-behavior: smooth;
  scroll-padding-left: max(${PADDING}, calc((100vw - ${WIDTH}) / 2));
  scroll-snap-type: x mandatory;
  scrollbar-width: none;

  ${phone(css`
    padding: 16px ${PADDING_PHONE};
    scroll-padding-left: ${PADDING_PHONE};
    scroll-padding-right: ${PADDING_PHONE};
  `)}

  &::-webkit-scrollbar {
    display: none;
  }
`
